import $ from 'jquery'

const ExactOnlineAccountSelector = class ExactOnlineAccountSelector {
  constructor($selector1, path) {
    this.$selector = $selector1
    path = Silverfin.Routes.autocomplete_admin_exact_online_accounts_path()
    const $autocomplete = this.$selector.find(
        '.exact-online-account-autocomplete'
      ),
      $autocompleteInput = $autocomplete.find('input'),
      $companyNameField = this.$selector.find(
        '#firm_exact_online_account_name'
      ),
      $companyCodeField = this.$selector.find(
        '#firm_exact_online_account_code'
      ),
      $companyIdField = this.$selector.find('#firm_exact_online_account_id'),
      $companyName = this.$selector.find('.exact-online-account-name'),
      $removeCompany = this.$selector.find('.exact-online-account-name i'),
      params = {},
      items = {}
    let names = []

    $autocompleteInput.typeahead({
      items: 10,
      minLength: 1,
      source: (query, process) => {
        params['q'] = query
        $.get(path, params, (data) => {
          names = []
          $.each(data, (_, item) => {
            const trimmedItem = { ...item, code: item.code.trim() }
            const nameWithCode = `${item.name} [${trimmedItem.code}]`
            items[nameWithCode] = trimmedItem
            return names.push(nameWithCode)
          })
          return process(names)
        })
        return null
      },
      updater: (itemName) => {
        const item = items[itemName]
        $companyNameField.val(item.name)
        $companyCodeField.val(item.code)
        $companyIdField.val(item.id)
        $companyName.find('span').html(itemName)
        $autocomplete.hide()
        $companyName.show()
        return itemName
      },
    })
    $removeCompany.click(() => {
      $autocompleteInput.val('')
      $companyNameField.val('')
      $companyIdField.val('')
      $autocomplete.show()
      return $companyName.hide()
    })
  }
}

export default ExactOnlineAccountSelector

$(document).on('turbolinks:load', () => {
  const $selector = $('[data-behaviour="exact-online-account-selector"]')

  if ($selector.length > 0) {
    return new ExactOnlineAccountSelector($selector)
  }
})
